import { useTranslation } from 'react-i18next'

import { ArrowRight } from '@phosphor-icons/react'

import { Link, Text } from '@reveni-io/reveni-ui'

import routes from '@/Router/routes.constants'

import * as Styles from './styles'

const ParcelLinks = ({ parcels }) => {
  const { t } = useTranslation()
  return (
    <Styles.LinksContainer>
      {parcels?.map(parcel => (
        <Styles.ParcelLinkContainer key={parcel.id}>
          <Link href={`${routes.parcelsPage.index}/${parcel.id}`} target="_blank" rel="noreferrer">
            <Text type="linkM">
              {t('Ir al detalle del envío')} {parcel.order?.name}
            </Text>
            <ArrowRight size={24} weight="light" />
          </Link>
        </Styles.ParcelLinkContainer>
      ))}
    </Styles.LinksContainer>
  )
}

export default ParcelLinks
